import type { VinceApp } from '../composables/usePermission';
import type { Action } from './roles';
import type { DropdownMenuItem } from 'vince-ui/types/common';
import type { ResourceType } from 'vince-core/types/common';

export enum Menu {
    MAIN = 'MAIN',
    SETTINGS = 'SETTINGS',
    ADMINISTRATION = 'ADMINISTRATION',
    INFO = 'INFO',
    APPS = 'APPS',
}
export enum SubHeader {
    ADMINISTRATION = 'ADMINISTRATION',
    REPORTS = 'REPORTS',
    SETTING = 'SETTING',
    COMPANY_SETTINGS = 'COMPANY_SETTINGS',
    AI_APPS = 'AI_APPS',
    WORKFLOW_SETTINGS = 'WORKFLOW_SETTINGS',
    WORKFLOW_MANAGEMENT = 'WORKFLOW_MANAGEMENT',
    EXTERNAL = 'EXTERNAL',
    INTERNAL_E2E_TESTS = 'INTERNAL_E2E_TESTS'
}

export interface MenuItem extends DropdownMenuItem {
    menu: Menu;
    position: number;
    subheader?: SubHeader;
    requiredPermission?: {
        app: VinceApp,
        resource?: ResourceType,
        resourceId?: string,
        action?: Action | '*'
    } | (() => boolean);
    count?: () => Promise<number>;
}
